import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '@Service';
import { REPORT_LIST_STALE_MS } from './useShiftReports';
import type {
  HotelReportSummary,
  HotelReportDetail,
} from '@Types/hotelReport';

export const hotelReportKeys = {
  forSoul: (soulId: string) => ['hotel-reports', 'soul', soulId] as const,
  detail: (id: string) => ['hotel-report', id] as const,
};

export function useHotelReports({
  soulId,
  enabled = true,
  refetchInterval = false,
}: {
  soulId?: string;
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  return useQuery<HotelReportSummary[]>({
    queryKey: hotelReportKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getHotelReports({ soulId: soulId! }),
    enabled: enabled && !!soulId,
    refetchInterval,
    staleTime: REPORT_LIST_STALE_MS,
  });
}

export function useHotelReport({
  id,
  enabled = true,
}: {
  id?: string;
  enabled?: boolean;
}) {
  return useQuery<HotelReportDetail>({
    queryKey: hotelReportKeys.detail(id!) as unknown as QueryKey,
    queryFn: () => service.getHotelReport(id!),
    enabled: enabled && !!id,
    // A persisted report never changes; reopening the sheet or refocusing the
    // window must not re-download its email HTML.
    staleTime: Infinity,
  });
}
